import {renderAuditSections} from '@/modules/auditorAudits/components/AuditorAuditSectionsDrawer';
import {renderAuditName} from '@/modules/auditorAudits/components/AuditNameCell';
import {renderAuditEstablishment} from '@/modules/auditorAudits/components/AuditEstablishmentCell';
import {renderSelectClient} from '@/modules/auditorAudits/components/AuditorAuditsSelectClients';
import {renderAuditorAuditDateRangeCell} from '@/modules/auditorAudits/components/AuditorAuditsDateRangeCell';
import AuditorAuditsSelectTemplateCell from '@/modules/auditorAudits/components/AuditorAuditsSelectTemplateCell';
import AuditorAuditsSummary from '@/modules/auditorAudits/components/AuditorAuditsSummary';
import {
  renderSelectEstablishment
} from '@/modules/auditorAudits/components/AuditorAuditsSelectEstablishment';
import {renderSelectService} from '@/modules/auditorAudits/components/AuditorAuditsSelectService';
// import {months} from '@/modules/audits/constants/months';
import AuditorAuditsSelectAuditor from '@/modules/auditorAudits/components/AuditorAuditsSelectAuditor';
import AuditorAuditsStartDate from '@/modules/auditorAudits/components/AuditorAuditsStartDate';
import {renderAuditOwner} from '@/modules/auditorAudits/components/AuditOwnerCell';

const fields = [
  {
    key: 'client',
    onlyView: true,
    renderView: renderAuditName
  },
  {
    key: 'establishment',
    onlyView: true,
    renderView: renderAuditEstablishment
  },
  {
    key: 'owner',
    onlyView: true,
    renderView: renderAuditOwner
  },
  {
    key: 'answers',
    className: 'mix-sections-cmp',
    onlyView: true,
    renderView: renderAuditSections,
  },
];

const auditorAuditsFields = [
  {
    title: 'setting',
    key: 'setting',
    required: true,
    fields: [
      { key: 'client', label: 'form.client', placeholder: 'form.select', required: true, render: renderSelectClient },
      { key: 'establishment', label: 'form.establishment', placeholder: 'form.select', required: true, render: renderSelectEstablishment, dependencies: ['client'], },
      { key: 'service', label: 'form.service', placeholder: 'form.select', required: true, render: renderSelectService, dependencies: ['establishment'] },
      // { key: 'month', label: 'form.month', placeholder: 'form.select', widget: 'select', options: months, colSpan: 1 },
      // { key: 'valueGoal', label: 'form.valueGoal', placeholder: 'form.placeholderValueGoal', colSpan: 1 },
      // { key: 'areaAccess', label: 'form.areaAccess', required: true, widget: SelectAreaAccess,  colSpan: 1 },
      { key: 'startDate', label: 'form.yearAndMonth', placeholder: 'form.select', widget: AuditorAuditsStartDate, colSpan: 1 },
      { key: 'date', label: 'form.date', render: renderAuditorAuditDateRangeCell, colSpan: 1},
      { key: 'auditor', label: 'form.auditor', placeholder: 'form.select', widget: AuditorAuditsSelectAuditor, colSpan: 2 },
    ],
  },
  {
    title: 'template',
    key: 'template',
    required: true,
    fields: [
      { key: 'template', label: '', widget: AuditorAuditsSelectTemplateCell },
    ],
  },
  {
    title: 'confirmation',
    key: 'confirmation',
    required: true,
    fields: [
      // eslint-disable-next-line react/display-name
      { key: 'summary', label: 'summary', render: ({...props}) => <AuditorAuditsSummary {...props} /> },
    ],
  },
];

export {
  fields,
  auditorAuditsFields,
};


